import RenderGroups from "./render-groups";

export default RenderGroups;
